module.exports = __webpack_public_path__ + "img/team-member-04.ea1badc0.jpg";